module.exports = __webpack_public_path__ + "media/images/google-omni-3ed9b524b580401b30b1d6d17a2a9ac5.svg";